import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { BUY_AGAIN_DEALS_FLAG } from '../../brands/default/constants';
import { LINK_BUY_AGAIN } from '../../brands/default/links';
import { BUY_AGAIN_ICON } from '../../config/constants/images';
import { redirectToURL } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';

const HeaderBuyAgain = () => {
  const router = useRouter();
  const theme = useContext(ThemeContext);
  const isLoggedIn = useSelector((state) => state.user.isAuthenticated);

  if (!isLoggedIn || localStorage.getItem(BUY_AGAIN_DEALS_FLAG) !== 'true')
    return null;

  const onClickIcon = () => {
    redirectToURL(LINK_BUY_AGAIN, router);
  };

  return (
    <>
      <div
        className="buy-again-icon"
        onClick={onClickIcon}
        onKeyDown={onClickIcon}
        role="link"
        tabIndex="0"
      >
        <img alt="" className="icon-image" src={BUY_AGAIN_ICON} />
        <div className="icon__tooltip">Buy Again</div>
      </div>

      <style jsx>{`
        .buy-again-icon {
          position: relative;
          display: inline-block;
          margin-right: 10px;
        }

        .icon-image {
          cursor: pointer;
          width: 32px;
          height: 32px;
        }

        .icon__tooltip {
          color: ${theme.colors.headerprimary};
          display: none;
          font-size: 12px;
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          white-space: nowrap;
        }

        .buy-again-icon:hover .icon__tooltip {
          display: block;
        }

        @media (max-width: ${theme.breakpoints.mdDown}) {
          .icon__tooltip {
            display: none !important;
          }
          .icon-image {
            width: 24px;
            height: 24px;
          }
        }
      `}</style>
    </>
  );
};

export default HeaderBuyAgain;
